import axios from '../axios.js';

var api = {
  //扫盲
  eliminate(){
    return axios.post('index/gre/index')
  },
  //统计
  statustic(){
    return axios.post('index/gre/library')
  },
  //免费下载
  freeDown(){
    return axios.post('index/gre/free')
  },
  //收费下载
  collectDown(){
    return axios.post('index/gre/charge')
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/jiJing.js